/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import { CommentArrowLeft16Regular, CommentMultiple16Regular, Tag16Regular } from '@fluentui/react-icons';
import { Stack } from '@fluentui/react/lib/Stack';
import * as React from 'react';
import { defineMessages } from 'react-intl';
import { BasicModal, BasicModalProps } from 'src/core/components/BasicModal';
import { LuisText } from 'src/core/components/LuisText';
import { useLocalization } from 'src/core/hooks/useLocalization';
import { withModalMounter } from 'src/core/utils/hocs/withModalMounter';

const messages = defineMessages({
    modalTitle: {
        id: 'qnaMaker.qnaMakerQnaCardLegendModal.modalTitle',
        defaultMessage: 'Icon key'
    },
    description: {
        id: 'qnaMaker.qnaMakerQnaCardLegendModal.description',
        defaultMessage:
            'Each row shows a preview of the question and answer of a particular question answer pair and has icons showing additional information about that pair.'
    },
    followUpPrompts: {
        id: 'qnaMaker.qnaMakerQnaCardLegendModal.followUpPrompts',
        defaultMessage: 'Follow up prompts'
    },
    alternateQuestions: {
        id: 'qnaMaker.qnaMakerQnaCardLegendModal.alternateQuestions',
        defaultMessage: 'Alternate questions'
    },
    metadata: {
        id: 'qnaMaker.qnaMakerQnaCardLegendModal.metadata',
        defaultMessage: 'Metadata'
    }
});

export const QnaMakerQnaCardLegendModal = withModalMounter((props: BasicModalProps<object>) => {
    const { onDismiss } = props;
    const { localize } = useLocalization();

    return (
        <BasicModal
            {...props}
            minWidth={560}
            onDismiss={onDismiss}
            shouldRenderFooter={false}
            dialogContentProps={{ title: localize(messages.modalTitle) }}>
            <Stack tokens={{ childrenGap: 20 }}>
                <LuisText>{localize(messages.description)}</LuisText>
                <Stack horizontal tokens={{ childrenGap: 10 }}>
                    <CommentMultiple16Regular />
                    <LuisText>{localize(messages.alternateQuestions)}</LuisText>
                </Stack>
                <Stack horizontal tokens={{ childrenGap: 10 }}>
                    <CommentArrowLeft16Regular />
                    <LuisText>{localize(messages.followUpPrompts)}</LuisText>
                </Stack>
                <Stack horizontal tokens={{ childrenGap: 10 }}>
                    <Tag16Regular />
                    <LuisText>{localize(messages.metadata)}</LuisText>
                </Stack>
            </Stack>
        </BasicModal>
    );
});
